import { z } from "zod";
const ExporterType = z.enum(["documentation", "code"]);
export const ListExporterQuery = z.object({
    limit: z.number().optional(),
    offset: z.number().optional(),
    type: ExporterType.optional(),
    search: z.string().optional(),
});
